import React from 'react'
import { Link } from 'react-router'
import { Stack, TableCell, TableRow } from '@mui/material'
import { ConvertibleAction } from 'types/ConvertibleAction'
import { formatBigMoney, formatNumber } from '../../../../packages/utils/numberFormatters'
import { KVLabel } from '../../../../components/entities/IssueTypeLabels'

interface ConvertibleActionTableRowProps {
    locale: string
    date: string
    convertibleAction: ConvertibleAction
    splitAdjust: boolean
    symbol?: string
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const ConvertibleActionTableRow = ({
    locale,
    date,
    convertibleAction,
    splitAdjust,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: ConvertibleActionTableRowProps) => {
    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{convertibleAction.symbol}</TableCell> : null}
            <TableCell>
                <Stack direction='row' spacing={2}>
                    <KVLabel />
                    <Link to={`/convertibles/${convertibleAction.convertibleId}`}>
                        {convertibleAction.convertibleName}
                    </Link>
                </Stack>
            </TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell>
                        {formatNumber(
                            convertibleAction.conversionPrice * (splitAdjust ? convertibleAction.splitAdjustment : 1),
                            {
                                locale,
                                minDecimals: 2,
                                maxDecimals: 5,
                            },
                        )}
                    </TableCell>
                    <TableCell>
                        {convertibleAction.convertedShares
                            ? formatNumber(
                                  convertibleAction.convertedShares /
                                      (splitAdjust ? convertibleAction.splitAdjustment : 1),
                                  {
                                      locale,
                                      decimals: 0,
                                  },
                              )
                            : '-'}
                    </TableCell>
                </>
            ) : null}
            <TableCell>
                {convertibleAction.convertedShares && convertibleAction.conversionPrice
                    ? formatBigMoney(convertibleAction.convertedShares * convertibleAction.conversionPrice, {
                          locale,
                          decimals: 0,
                      })
                    : '-'}
            </TableCell>
        </TableRow>
    )
}
